import {forwardRef, useImperativeHandle} from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {currentTheme} from '../../../../store/reducers/preferences';
import {FormLabel, Stack} from '@mui/material';
import AgyleButton from '../../../ui/buttons/agyleButton';
import {OPTION_BUTTONS_DEFAULT_GAP} from '../userProperties';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';

const DefaultTheme = forwardRef((props, ref) => {
    const { t } = useTranslation();
    const currentUsedTheme = useSelector(currentTheme);

    // Return default state of a component
    useImperativeHandle(ref, () => ({
        defaultState: () => {
            return currentUsedTheme;
        },
    }));

    const onThemeChange = (value) => {
        if (value === props.currentTheme) return;
        props.onChange(value);
    }

    return (
      <div>
          <FormLabel>
              {t('Color Modes')}
          </FormLabel>

          <Stack direction='row' gap={OPTION_BUTTONS_DEFAULT_GAP} sx={{mt: 1, my: .5}}>
              <AgyleButton
                startIcon={<LightModeOutlinedIcon />}
                onClick={() => onThemeChange('light')}
                variant={props.currentTheme === 'light' ? 'contained' : 'outlined'}
              >
                  {t('Light')}
              </AgyleButton>

              <AgyleButton
                startIcon={<DarkModeOutlinedIcon />}
                onClick={() => onThemeChange('dark')}
                variant={props.currentTheme === 'dark' ? 'contained' : 'outlined'}
              >
                  {t('Dark')}
              </AgyleButton>
          </Stack>
      </div>
    );
});

export default DefaultTheme;
